module.exports = __webpack_public_path__ + "static/pumps_agriculture-8773a8c7330c8d2ec5f181ce855ceacf.png";